import { render, staticRenderFns } from "./IndexationEditWidget.vue?vue&type=template&id=28632524&"
import script from "./IndexationEditWidget.vue?vue&type=script&lang=js&"
export * from "./IndexationEditWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports